import StatusBadge from 'components/atoms/status-badge'
import { CONFIRM_PRICE_STATUS } from 'domains/seller-product/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  confirm_price_status: PropTypes.string
}

/**
 * To give nice look on Seller Product `confirm_price_status`.
 * It maps `confirm_price_status` to certain style and pass to `StatusBadge`.
 * @param {string} confirm_price_status Seller Product price confirm status. available values
 * - `seller_confirmed`
 * - `pending`
 */
const SellerProductPriceConfirmStatusBadge = ({ confirm_price_status }) => {

  const colorMap = {
    [CONFIRM_PRICE_STATUS.SELLER_CONFIRMED] : 'primary',
    [CONFIRM_PRICE_STATUS.PENDING]          : 'warning'
  }

  const color = colorMap[confirm_price_status] || 'default'

  return <StatusBadge color={ color } label={ confirm_price_status } />
}

SellerProductPriceConfirmStatusBadge.propTypes = proptypes

export default SellerProductPriceConfirmStatusBadge
